import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MultiSelect } from 'src/@/components/ui/multi-select';
import { Button } from 'src/@/components/ui/button';
import { Input } from 'src/@/components/ui/input';
import { Textarea } from 'src/@/components/ui/textarea';
import { Label } from 'src/@/components/ui/label';
import { Switch } from 'src/@/components/ui/switch';
import { Separator } from 'src/@/components/ui/separator';
import Iconify from 'src/components/Iconify';
import v2_actionClienteConfigCheck from 'src/actions/v2/cliente/v2_actionCheck';
import v2_actionEditarCliente from 'src/actions/v2/cliente/v2_actionEditarCliente';

// material
import useAuth from 'src/hooks/useAuth';

export default function AnaliseAtendimento() {
    const { logout, user, cliente } = useAuth();
    const navigate = useNavigate();
    const [prompt, setPrompt] = useState('');
    const [quantidadeMensagens, setQuantidadeMensagens] = useState(10);
    const [momentosAnalise, setMomentosAnalise] = useState([]);
    const [isAtivo, setIsAtivo] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const opcoesMomentos = [
        { label: 'Ao finalizar chat', value: 'finalizar' },
        { label: 'Durante o Chat', value: 'durante' }
    ];

    const newOpcoesMomentos = opcoesMomentos;

    const handleSalvar = async () => {
        try {
            setIsLoading(true);
            let data = {
                scope: {
                    "config.modules.aiAnalysisChat.status": isAtivo,
                    "config.modules.aiAnalysisChat.numberMsgs": quantidadeMensagens,
                    "config.modules.aiAnalysisChat.operation": momentosAnalise
                }
            };

            console.log('Dados a serem enviados:', data); // Para debug

            const response = await v2_actionEditarCliente(cliente._id, data);

            if (response.data.error === false) {
                // Atualizar o estado com os dados salvos
                const { aiAnalysisChat } = response.data.data.scope["config.modules"];
                setIsAtivo(aiAnalysisChat.status);
                setQuantidadeMensagens(aiAnalysisChat.numberMsgs)
             

                if (aiAnalysisChat.operation && aiAnalysisChat.operation.length > 0) {
                    setMomentosAnalise(aiAnalysisChat.operation);
                } else {
                    setMomentosAnalise([]);
                }
            }
        } catch (error) {
            console.error('Erro ao salvar configurações:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const response = await v2_actionClienteConfigCheck(cliente._id, 'aiCheck,configModules');
                if (response.data.error === false) {
                    const { aiAnalysisChat } = response.data.data.configModules;
                    console.log('Dados recebidos do servidor:', aiAnalysisChat);
                    setIsAtivo(aiAnalysisChat.status);
                    setQuantidadeMensagens(aiAnalysisChat.numberMsgs);
 
                    if (aiAnalysisChat.operation && aiAnalysisChat.operation.length > 0) {
                        console.log('Momentos de análise recebidos:', aiAnalysisChat.operation);
                        const valoresValidos = aiAnalysisChat.operation
                            .map(String)
                            .filter(valor => newOpcoesMomentos.some(op => op.value === valor));
                        setMomentosAnalise(valoresValidos);
                    } else {
                        console.log('Nenhum momento de análise recebido');
                        setMomentosAnalise([]);
                    }
                }
            } catch (error) {
                console.error('Erro ao buscar configurações:', error);
            }
        };

        if (cliente?._id) {
            fetchConfig();
        }
    }, [cliente?._id]);

    // Adicionar log para monitorar mudanças no estado
    useEffect(() => {
        console.log('Estado atual de momentosAnalise:', momentosAnalise);
        console.log('Opções disponíveis:', newOpcoesMomentos);
    }, [momentosAnalise, newOpcoesMomentos]);

    return (
        <div className="container mx-auto p-4">
            <div className="flex flex-row items-center justify-between mb-6">
                <div className="flex flex-row items-center gap-2">
                    <Button
                        size="icon"
                        variant="outline"
                        onClick={() => navigate('/dashboard/configuracoes/modulos')}
                    >
                        <Iconify icon="majesticons:arrow-left" color="black" />
                    </Button>
                    <h2 className="text-2xl font-semibold">Análise de Atendimento</h2>
                </div>
                <Button
                    variant="default"
                    size="sm"
                    onClick={handleSalvar}
                    disabled={isLoading}
                >
                    {isLoading ? 'Salvando...' : 'Salvar'}
                </Button>
            </div>

            <Separator className="mb-6" />

            <div className="grid grid-cols-1 gap-6">
                <div className="flex flex-row gap-4 items-center">
                    <Label htmlFor="status" className="min-w-[200px] text-right">Status</Label>
                    <div className="flex flex-row gap-2 items-center">
                        <Switch
                            id="status"
                            checked={isAtivo}
                            onCheckedChange={setIsAtivo}
                        />
                        <p className="text-sm text-muted-foreground">
                            Ative ou desative a análise de atendimento
                        </p>
                    </div>
                </div>

                <div className="flex flex-row gap-4 items-center">
                    <Label htmlFor="quantidade" className="min-w-[200px] text-right">Mensagens até a análise</Label>
                    <div className="flex flex-row gap-2 items-center">
                        <Input
                            id="quantidade"
                            type="number"
                            value={quantidadeMensagens}
                            onChange={(e) => setQuantidadeMensagens(Number(e.target.value))}
                            min={1}
                            className="w-[100px]"
                        />
                        <p className="text-sm text-muted-foreground">
                            Número de mensagens enviadas pelo cliente necessárias para gerar próxima análise
                        </p>
                    </div>
                </div>

                <div className="flex flex-row gap-4 items-center">
                    <Label className="min-w-[200px] text-right">Atuação da Análise</Label>
                    <div className="flex flex-col gap-2">
                        <MultiSelect
                            options={newOpcoesMomentos}
                            defaultValue={momentosAnalise}
                            onValueChange={(newValue) => {
                                console.log('Novo valor selecionado:', newValue);
                                setMomentosAnalise(newValue);
                            }}
                            labelledBy="Selecione os momentos"
                            hasSelectAll={true}
                            className="w-[300px]"
                            placeholder="Selecione os momentos"
                        />
                        <p className="text-sm text-muted-foreground">
                            Selecione quando a análise deve ser gerada
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
